import React, { useCallback } from "react"
import { Col, Row } from "react-bootstrap"
import styled from "styled-components"
import { State, useHookstate } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import FilePicker from "../../components/FilePicker"
import Section from "../../components/Section"
import { PrintCatalog } from "../../globalStates/ExhibitorDataTypes"

const LogoDescription = styled.label`
    margin-top: 40px;
    white-space: break-spaces;
`

interface LogoBackgroundImageSectionProps {
    printCatalogState: State<PrintCatalog, Validation>
    readOnly: boolean
}

const LogoBackgroundImageSection: React.FC<LogoBackgroundImageSectionProps> = ({ printCatalogState, readOnly }) => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()
    const printCatalog = useHookstate(printCatalogState)

    const onChangeLogo = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("PRINT_LOGO", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        printCatalog.logoFileId.set(response.fileId)
                        printCatalog.logoUrl.set(response.fileUrl)
                        printCatalog.fileType.set(response.contentType)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, printCatalog]
    )

    const onRemoveLogo = useCallback(() => {
        printCatalog.logoFileId.set("")
        printCatalog.logoUrl.set("")
    }, [printCatalog])

    return (
        <Section title={branding.configuration.printPage.sctLogoBackgroundImage.lblSectionTitleLogoBackground}>
            <Row>
                <Col sm={12} md={3}>
                    <FilePicker
                        name="companyLogo"
                        label={branding.configuration.printPage.sctLogoBackgroundImage.lblCompanyLogo}
                        placeholderTitle={branding.configuration.printPage.sctLogoBackgroundImage.hntTitle}
                        placeholderText={branding.configuration.printPage.sctLogoBackgroundImage.hntProp}
                        browseLabel={branding.configuration.printPage.sctLogoBackgroundImage.btnBrowseFiles}
                        deleteLabel={branding.configuration.printPage.sctLogoBackgroundImage.btnDeleteImg}
                        value={printCatalog.logoUrl.get()}
                        fileType={printCatalog.fileType.get() || "DMY"}
                        acceptFilter="image/jpeg, image/jpg, image/tif, image/tiff, application/pdf, .ai, .eps"
                        readonly={readOnly}
                        onChangeImage={onChangeLogo}
                        onRemoveImage={onRemoveLogo}
                    />
                </Col>
                <Col sm={12} md={9}>
                    <LogoDescription>
                        {branding.configuration.printPage.sctLogoBackgroundImage.lblCompanyLogoImageMessage}
                    </LogoDescription>
                </Col>
            </Row>
        </Section>
    )
}

export default LogoBackgroundImageSection
